import React from 'react';

export const CardHeader = ({ title, subtitle, action, className = '' }) => (
  <div className={`px-6 py-4 border-b border-slate-100 dark:border-slate-700/80 flex items-center justify-between ${className}`}>
    <div>
      {title && (
        <h3 className="text-base font-semibold text-slate-900 dark:text-slate-100">
          {title}
        </h3>
      )}
      {subtitle && (
        <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
          {subtitle}
        </p>
      )}
    </div>
    {action && <div className="flex items-center gap-2">{action}</div>}
  </div>
);

export const CardBody = ({ children, className = '' }) => (
  <div className={`p-6 ${className}`}>{children}</div>
);

export const CardFooter = ({ children, className = '' }) => (
  <div className={`px-6 py-3.5 border-t border-slate-100 dark:border-slate-700/80 bg-slate-50/50 dark:bg-slate-800/50 rounded-b-xl ${className}`}>
    {children}
  </div>
);

const GlassmorphicCard = ({ children, className = '', title, subtitle, action, bodyClassName = '', noPadding = false }) => {
  return (
    <div className={`bg-white dark:bg-[#1e293b] border border-slate-200/80 dark:border-slate-700/80 rounded-xl shadow-[0_4px_20px_0_rgba(0,0,0,0.04)] dark:shadow-[0_4px_20px_0_rgba(0,0,0,0.25)] transition-all duration-200 ${className}`}>
      {(title || action) && (
        <CardHeader title={title} subtitle={subtitle} action={action} />
      )}
      <div className={noPadding ? bodyClassName : `p-6 ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
};

export default GlassmorphicCard;
